/* Built In Imports */
import { useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import { consoleLog } from '@components/Utility/Shared/SharedService';
/* Services */

/**
 * Renders the ProgramFinder component.
 * @returns {ReactElement} Program Finder component.
 */
const ProgramFinderUS = () => {
  const getScript = url =>
    new Promise((resolve, reject) => {
      consoleLog('getScript');
      const script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.onerror = reject;
      script.onload = script.onreadystatechange = function () {
        const loadState = this.readyState;
        if (loadState && loadState !== 'loaded' && loadState !== 'complete')
          return;
        script.onload = script.onreadystatechange = null;
        resolve();
      };

      document.head.appendChild(script);
    });

  const loadPrsSchedule = () => {
    PrsSchedule.initISOFull({
      divId: 'programFinder',
      title: 'Program/Event Finder',
      minHeight: '300',
    });
  };

  useEffect(() => {
    if (typeof PrsSchedule === 'undefined') {
      consoleLog('PrsSchedule === undefined');
      getScript(
        (location.origin == 'https://isha.sadhguru.org'
          ? 'https://online.innerengineering.com/'
          : 'https://staging.innerengineering.com/') +
          'schedule-assets/js/embed.js'
      ).then(loadPrsSchedule);
    } else {
      consoleLog('loadForm');
      loadPrsSchedule();
    }

    return () => {
      // document.removeChild(script);
    };
  }, []);

  return <Box id="programFinder"></Box>;
};

export default ProgramFinderUS;
